import throttle from 'lodash/throttle';
import getRemBase from '../../../js/__utils/getRemBase';

const heroFormBlocks = document.querySelectorAll('.block-hero-form');

const updateHeroFormStatBlockHeight = () => {
	if (heroFormBlocks.length > 0) {
		heroFormBlocks.forEach((block) => {
			const content = block.querySelector('.block-hero-form__content');
			const statBlock = block.querySelector('.block-stat-simple');
			const formBlock = block.querySelector('.block-form');

			if (statBlock) {
				block.style.setProperty(
					'--stat-block-height',
					`${Math.ceil(statBlock.offsetHeight) - 1}px`
				);
			}

			if (formBlock) {
				const formBlockRect = formBlock.getBoundingClientRect();
				let contentBottomGap = 80;

				if (
					formBlockRect.top + formBlockRect.height >
					window.innerHeight
				) {
					contentBottomGap =
						formBlockRect.top +
						formBlockRect.height -
						window.innerHeight +
						80;
				}

				block.style.setProperty(
					'--content-bottom-gap',
					`${contentBottomGap / getRemBase()}rem`
				);

				content?.classList.add('fade-in');
			}
		});
	}
};

updateHeroFormStatBlockHeight();

window.addEventListener('resize', throttle(updateHeroFormStatBlockHeight, 100));
